import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VersionHelpersModule } from '../helpers/helpers.module';

import { FilesListModule } from '@core/components/files/lists/lists.module';
import { HelperIconsModule } from '@core/components/helpers/icons/icons.module';
import { LabelsModule } from '@core/components/labels/labels.module';

import { VersionsSummaryStatusBoxComponent } from './summary-status-box/summary-status-box.component';

@NgModule({
    imports: [
        CommonModule,
        FilesListModule,
        LabelsModule,
        HelperIconsModule,
        VersionHelpersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        VersionsSummaryStatusBoxComponent
    ],
    exports: [
        VersionsSummaryStatusBoxComponent
    ],

})
export class AppVersionsSummaryModule{ }
